import React from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";

import HeroImage from "../../assets/images/strawberry-hero.png";

import elmecoLogo from "../../assets/images/logo-elmeco.jpg";

import elmecoBigBiz from "../../assets/images/BigBiz2.png";
import elmecoFistClass from "../../assets/images/FirstClass.png";

function Dispensing() {
  return (
    <div>
      <Helmet>
        <title>Dispensing</title>
      </Helmet>

      <Header />

      <div>
        <HeroSection
          backgroundImage={HeroImage}
          title="Perfect Slushies, Every Time"
          subtitle="Explore Our Range of Slush Machines"
          dividerPath="M0,128L48,160C96,192,192,256,288,277.3C384,299,480,277,576,240C672,203,768,149,864,138.7C960,128,1056,160,1152,176C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          dividerColour="white"
        />
      </div>

      <div style={{ display: "flex", justifyContent: "center"}}>
        <img style={{maxWidth: "90%"}} alt="Elmeco Logo" src={elmecoLogo} />
      </div>

      {/* Elmeco machines */}

      <div
        className="ImgTextSection machineSection"
        style={{ paddingTop: "0" }}
      >
        <div className="SectionLeft">
          <div className="TextContainer">
            <h2>Elmeco BigBiz 1 and 2 bowl options</h2>
            <h3>Compact & Cost-Effective</h3>
            <p>
              <strong>
                Low-cost, smaller option where space is a premium.
              </strong>
            </p>

            <h3>Design & Colors</h3>
            <p>
              <strong>Stock in Black, other colours available on request.</strong>
            </p>
            <p>
              Side panels available in:{" "}
              <strong>Blue, Violet, Yellow, or Black</strong>
            </p>

            <h3>Key Features</h3>
            <ul>
              <li>
                Full access to all components for quick and easy maintenance
              </li>
              <li>
                Simple bowl extraction for easy cleaning, ensuring perfect
                hygiene
              </li>
              <li>Auto diagnostic system</li>
              <li>Electronic consistency control</li>
              <li>Drink refrigeration function</li>
              <li>Quick product preparation</li>
            </ul>

            <h3>Technical Specifications</h3>
            <p>
              <strong>Tank capacity:</strong> 6 litres each
            </p>
            <p>
              <strong>Voltage:</strong> 230V / 50Hz
            </p>

            <a href="/pdf/Brochure-BigBiz.pdf" target="_blank">
              Download the BigBiz Brochure
            </a>
          </div>
        </div>
        <div className="SectionRight">
          <div className="ImageContainer">
            <img
              src={elmecoBigBiz}
              alt="Blendz slushy machine"
              className="ContentImages"
              style={{ transform: "scalex(-1)" }}
            />
          </div>
        </div>
      </div>

      <div
        className="ImgTextSection machineSection"
        style={{ backgroundColor: "var(--shading-colour)" }}
      >
        <div className="SectionLeft">
          <div className="ImageContainer">
            <img
              src={elmecoFistClass}
              alt="Blendz slushy machine"
              className="ContentImages"
            />
          </div>
        </div>
        <div className="SectionRight">
          <div className="TextContainer">
            <h2>Elmeco First Class Millennium 1, 2 and 3 bowl options</h2>
            <p>
              <strong>
                All our stock is in Black, other colours available on request.
              </strong>
            </p>

            <h3>Front and Side Panels</h3>
            <p>Stainless steel can be customized with your logo.</p>

            <h3>Key Features</h3>
            <ul>
              <li>
                Patented "total cold" cooling system allows perfect product
                temperature until the very last drop
              </li>
              <li>
                Double auger and simple bowl extraction for easy cleaning,
                ensuring perfect hygiene
              </li>
              <li>Compressor overload and stirring mechanism protection</li>
              <li>Electronic density control</li>
              <li>Programmable timer with date and time</li>
              <li>Defrost function</li>
              <li>Auto fill option available</li>
              <li>All units are supplied with lid illumination system</li>
            </ul>

            <h3>Technical Specifications</h3>
            <p>
              <strong>Tank capacity:</strong> 12 litres each
            </p>
            <p>
              <strong>Voltage:</strong> 230V / 50Hz
            </p>

            <a href="/pdf/Brochure-First-Class.pdf" target="_blank">
              Download the First Class Brochure
            </a>

            <br />

            <a href="https://www.elmeco.com" target="noreferrer">
              Visit the Elmeco website
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dispensing;
